import { z } from 'zod';

const isoDateTime = () => z.string().datetime({ offset: true });

export const locationSchema = z.object({
  id: z.string().uuid(),
  clientId: z.string().uuid(),
  managerId: z.string().uuid().nullable(),
  name: z.string().min(1).optional().nullable(), // Property name like "Skyline Plaza"
  addressLine1: z.string().min(1).optional().nullable(),
  addressLine2: z.string().min(1).optional().nullable(),
  city: z.string().min(1),
  state: z.string().min(1).optional().nullable(),
  zip: z.string().min(1).optional().nullable(),
  fullAddress: z.string().min(1).optional(), // Computed field
  // One photo of the building at this address. Keys are stored; the URLs are
  // presigned per request by the single-location read, never persisted.
  photoR2Key: z.string().nullable().optional(),
  photoThumbKey: z.string().nullable().optional(),
  photoUrl: z.string().nullable().optional(),
  photoThumbUrl: z.string().nullable().optional(),
  createdAt: isoDateTime(),
  updatedAt: isoDateTime(),
});

const optionalString = (minLength: number = 1) =>
  z.string().min(minLength).optional().nullable().or(z.literal('').transform(() => undefined));

const locationInputBaseSchema = z.object({
  clientId: z.string().uuid(),
  managerId: z.string().uuid().nullable().optional(),
  name: optionalString(),
  addressLine1: optionalString(),
  addressLine2: optionalString(),
  city: z.string().min(1),
  state: z.string().length(2, 'Use 2-letter state code').optional().nullable().or(z.literal('').transform(() => undefined)),
  zip: optionalString(),
});

export const locationInputSchema = locationInputBaseSchema.refine(
  (data) => data.name || data.addressLine1,
  { message: 'Either name or addressLine1 must be provided', path: ['name'] }
);

export const locationUpdateSchema = locationInputBaseSchema.partial();
